<template>
  <div class="application-page-creation-banner">
    <div class="content">
      <h2 class="title">Хотите попасть в топ популярных компаний?</h2>
      <p class="description">Тогда создавайте собственную страницу о вашей компании у нас.</p>
    </div>
    <BaseButton class="button" name="Создать страницу" size="xl" @click="$emit('on-click')" />
    <div class="image-bg"></div>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'

  const img = useImage()
  const lampUrl = `url(${img('/banners/application-page-creation/lamp.png', { format: 'webp' })})`
  const lampTabletUrl = `url(${img('/banners/application-page-creation/lamp-tablet.png', { format: 'webp' })})`
  const lampMobileUrl = `url(${img('/banners/application-page-creation/lamp-mobile.png', { format: 'webp' })})`

  defineEmits(['on-click'])
</script>

<style lang="scss" scoped>
  .application-page-creation-banner {
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1280px;
    width: 100%;
    padding: 27px 48px 33px 32px;
    border-radius: 20px;
    background:
      linear-gradient(91deg, #b0ecff 0%, #b1ffb1 100%),
      linear-gradient(90deg, #f8ebb7 0%, #fffdf3 100%);

    @include vp-1023 {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    > .image-bg {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: v-bind(lampUrl);
      background-repeat: no-repeat;
      background-position: right top;
      background-size: auto 100%;

      @include vp-1439 {
        background-position: right -100px top;
      }

      @include vp-1279 {
        background-position: right -210px top;
      }

      @include vp-1023 {
        background-image: v-bind(lampTabletUrl);
        background-position: right top;
      }

      @include vp-767 {
        background-image: v-bind(lampMobileUrl);
        background-position: right bottom;
        background-size: auto;
      }
    }

    > .button {
      z-index: 5;
    }

    > .content {
      z-index: 5;
      max-width: 639px;

      @include vp-1023 {
        max-width: 373px;
      }

      @include vp-767 {
        max-width: 100%;
      }
    }

    > .content > .title {
      margin-bottom: 16px;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      color: $color-potato-90;

      @include vp-1023 {
        margin-bottom: 12px;
      }

      @include vp-767 {
        margin-bottom: 16px;
      }
    }

    > .content > .description {
      font-size: 16px;
      line-height: 24px;
      color: $color-potato-90;

      @include vp-1023 {
        margin-bottom: 12px;
      }

      @include vp-767 {
        margin-bottom: 70px;
        font-size: 14px;
        line-height: 22px;
      }
    }

    > .svoi-button {
      background-color: $color-kiwi-50;
    }
  }
</style>
